module.exports = __webpack_public_path__ + "img/hengxian.1a7c71c4.svg";